import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useCallback, useEffect, useRef, useState } from "react";
import { setColumnWidth } from "../../../helpers/cookieUtils";
import ListingHeader from "../listingHeader/ListingHeader";
import {
  Tooltip,
  TableCellLayout,
  Avatar,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  makeStyles,
} from "@fluentui/react-components";
import HoverCard from "../../hoverCard/HoverCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import {
  AttachementIcon,
  CheckmarkCircleIcon,
  DeleteIcon,
  DismissCircleIcon,
  EditIcon,
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  RemindIcon,
} from "../../../modules/default-svg";
import { dateOnlyFormatted } from "../../../utils/systemSettings";
import userService from "../../../store/services/user.service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { generalActions } from "../../../store/actions";
import CustomSelect from "../select/CustomSelect";
import Spin from "../spinner/Spin";
import clientService from "../../../store/services/clients.service";
import riskService from "../../../store/services/risks.service";
import searchService from "../../../store/services/search.service";
import { apiCall } from "../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../store/services/URL";
import {
  changeRequestTypes,
  compareArrays,
  getDeletePermission,
  getEditPermission,
  getLabelByType,
  getRiskSeverityColorClass,
  getRiskSeverityStatus,
  getRiskTrendingColorClass,
  processDescription,
  renderHealthStatus,
  sanitizeHtml,
  sortColumnsByOrderlist,
} from "../../../helpers/utils";
import {
  createRiskRequest,
  updateRiskFlag,
  updateRiskRequest,
} from "../../../store/actions/risks.actions";
import SafeHtml from "../../safeHtml/SafeHtml";
import { useColumnConfig } from "./ColumnConfigProvider";
import {
  isValidDate,
  localDateToISODateString,
} from "../../../utils/systemSettings";
import { debounce } from "lodash";
import TableCellSafeHtml from "../../safeHtml/TableCellSafeHtml";
import { createSkeletonRows, useTableContextChange } from "./utils/tableUtils";

const setRequestType = (type) => {
  switch (type) {
    case "Scope":
      return 0;
    case "Schedule":
      return 1;
    case "Budget":
      return 2;
    case "Quality":
      return 3;
    case "Resource":
      return 4;
    default:
      return 0;
  }
};

const setRiskStatus = (type) => {
  switch (type) {
    case "Identified":
      return 0;
    case "Opened":
      return 1;
    case "Monitoring":
      return 2;
    case "Escalated":
      return 3;
    case "Impacted":
      return 4;
    case "Closed":
      return 5;
    default:
      return 0;
  }
};

const getRequestType = (type) => {
  switch (type) {
    case 0:
      return "Scope";
    case 1:
      return "Schedule";
    case 2:
      return "Budget";
    case 3:
      return "Quality";
    case 4:
      return "Resource";
    default:
      return "Scope";
  }
};

const getRiskStatus = (type) => {
  switch (type) {
    case 0:
      return "Identified";
    case 1:
      return "Opened";
    case 2:
      return "Monitoring";
    case 3:
      return "Escalated";
    case 4:
      return "Impacted";
    case 5:
      return "Closed";
    default:
      return "Identified";
  }
};

const EditInput = ({
  label,
  value,
  onChange,
  type,
  onBlur,
  dateFormat,
  clientId,
  portfolioId,
  programId,
  projectId,
  table,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [resources, setResources] = useState([]);
  const [clients, setClients] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [scopes, setScopes] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [changeRequests, setChangeRequests] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);

  const formatValue = (val) => {
    if (!val) return null;
    if (val.label && val.value) return val;
    return { label: val.name, value: val.id };
  };

  const handleDateChange = (newDate) => {
    if (isValidDate(newDate)) {
      const newValue = localDateToISODateString(newDate);
      setInputValue(newValue);
      onChange(newValue);
    }
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const searchHandler = (value) => {
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  const searchClientHandler = (value) => {
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    let queryParam = `?clientId=${clientId}&searchTerm=${value}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    queryParam = queryParam + `clientId=${clientId}&portfolioId=${portfolioId}`;

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const searchProjectHandler = (value) => {
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (portfolioId) {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }
    if (programId) {
      queryParam = queryParam + `&programId=${programId}`;
    }
    if (portfolioId && programId) {
      queryParam =
        queryParam + `&portfolioId=${portfolioId}&programId=${programId}`;
    }
    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const searchChangRequestHandler = (value) => {
    riskService
      .searchChangeRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setChangeRequests(transformedArray);
      })
      .catch(() => {
        setChangeRequests([]);
      });
  };

  const searchScopeHandler = (value) => {
    searchService
      .Scopes(value, { projectId: projectId })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setScopes(transformedArray);
      })
      .catch(() => {
        setScopes([]);
      });
  };

  const searchTaskHandler = (value) => {
    searchService
      .Tasks(value, { projectId })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setTasks(transformedArray);
      })
      .catch(() => {
        setTasks([]);
      });
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSelectChange = (item) => {
    if (!item) return;
    const newValue = { id: item.value, name: item.label };
    handleInputChange(newValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const creatingRowState = table.getState().creatingRow;
      if (table?.options?.onCreatingRowSave && creatingRowState) {
        const currentValues = {
          ...creatingRowState.values,
        };
        table.options.onCreatingRowSave({
          values: currentValues,
          table,
        });
      }
    }
  };

  if (type === "text") {
    return (
      <input
        placeholder={`Enter ${label}`}
        defaultValue={inputValue}
        type="text"
        onChange={(e) => handleInputChange(e.target.value)}
        className="Custom-Input"
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
      />
    );
  }

  if (type === "number") {
    return (
      <input
        placeholder={`Enter ${label}`}
        defaultValue={inputValue}
        type="number"
        min={0}
        onChange={(e) => handleInputChange(+e.target.value)}
        className="Custom-Input"
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
      />
    );
  }

  const dropdownHandler = () => {
    if (label === "Type") {
      setDropdownOptions(() =>
        changeRequestTypes.map((item) => ({
          label: item.name,
          value: setRequestType(item.value),
        }))
      );
    } else if (label === "Status") {
      setDropdownOptions(() =>
        [
          { name: "Identified", value: 0 },
          { name: "Opened", value: 1 },
          { name: "Monitoring", value: 2 },
          { name: "Escalated", value: 3 },
          { name: "Impacted", value: 4 },
          { name: "Closed", value: 5 },
        ].map((item) => ({
          label: item.name,
          value: item.value,
        }))
      );
    } else if (label === "Probability") {
      setDropdownOptions(() =>
        [1, 2, 3, 4, 5].map((item) => ({
          label: item,
          value: item,
        }))
      );
    } else if (label === "Impact") {
      setDropdownOptions(() =>
        [1, 2, 3, 4, 5].map((item) => ({
          label: item,
          value: item,
        }))
      );
    } else if (label === "Is Issue") {
      setDropdownOptions(() =>
        [
          { name: "Yes", value: 1 },
          { name: "No", value: 0 },
        ].map((item) => ({
          label: item.name,
          value: item.value,
        }))
      );
    }
  };

  if (type === "select") {
    let searchTextFunc = searchHandler;
    let options = resources;
    let selectText = "prime";
    if (label === "Client") {
      searchTextFunc = searchClientHandler;
      options = clients;
      selectText = "client";
    } else if (label === "Portfolio") {
      searchTextFunc = searchPortfolioHandler;
      options = portfolioOptions;
      selectText = "portfolio";
    } else if (label === "Program") {
      searchTextFunc = searchProgramHandler;
      options = programs;
      selectText = "program";
    } else if (label === "Project") {
      searchTextFunc = searchProjectHandler;
      options = projectOptions;
      selectText = "project";
    } else if (label === "Change Request") {
      searchTextFunc = searchChangRequestHandler;
      options = changeRequests;
      selectText = "change request";
    } else if (label === "Type") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "type";
    } else if (label === "Status") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "status";
    } else if (label === "Probability") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "probability";
    } else if (label === "Impact") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "impact";
    } else if (label === "Is Issue") {
      searchTextFunc = dropdownHandler;
      options = dropdownOptions;
      selectText = "";
    } else if (label === "Affected Scope") {
      searchTextFunc = searchScopeHandler;
      options = scopes;
      selectText = "scope";
    } else if (label === "Affected Task") {
      searchTextFunc = searchTaskHandler;
      options = tasks;
      selectText = "task";
    }

    return (
      <div className="d-flex align-items-center w-full max-w-md mx-auto">
        <CustomSelect
          searchText={searchTextFunc}
          SelectText={selectText}
          CustomClass="ModalAvatarSearch CustomSelect"
          options={options}
          value={formatValue(value)}
          onChange={handleSelectChange}
          creatable={false}
          setCreated={handleSelectChange}
          handleBlur={onBlur}
          isDatatable
          selectWd="w-100"
          onKeyDown={handleKeyDown}
        />
      </div>
    );
  }

  return (
    <DatePicker
      selected={inputValue ? moment(inputValue).toDate() : null}
      onChange={handleDateChange}
      dateFormat={dateFormat}
      className="CustomDatePickerInput"
      onBlur={onBlur}
      popperPlacement="bottom-start"
      placeholderText={dateFormat}
      onKeyDown={handleKeyDown}
      popperClassName="CustomDatePickerPopper"
      showPopperArrow={false}
    />
  );
};

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const RiskTable = (props) => {
  const {
    columnsList,
    rowData,
    setIsCreate,
    searchHandler,
    tableName,
    handleColumnOrdering,
    dispatch,
    setPageNum,
    perPageItems,
    pagination,
    handleReminder,
    handleEdit,
    handleDelete,
    overviewType,
    dashboardFilterSetId,
    dashboardFilterSetName,
    parentType,
    portfolioId,
    programId,
    projectId,
    riskLoading,
    handleAddRow,
    handleCancelAddRow,
    setRowData,
    isHeader,
    triggerSearch,
  } = props;
  const styles = useStyles();
  const [cols, setCols] = useState([]);
  const [colsList, setColumnsList] = useState([]);
  const [rows, setRows] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const setting = JSON.parse(localStorage.getItem("settings"));
  const [editedRows, setEditedRows] = useState({});
  const tableContainerRef = useRef(null);
  const lastScrollTop = useRef(0);
  const selectRefs = useRef({});
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const [editingHeader, setEditingHeader] = useState(null);
  const [headerValue, setHeaderValue] = useState("");
  const [columnSizing, setColumnSizing] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [popoverStates, setPopoverStates] = useState({});
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const { hasContextChanged } = useTableContextChange({
    contextValues: {
      portfolioId,
      programId,
      projectId,
      parentType
    },
    setIsFetchingMore,
    setRows,
    setRowData,
  });

  useEffect(() => {
    if (columnsList.length) {
      setColumnsList(columnsList);
    }
  }, [columnsList]);
  const handlePopoverChange = (itemId, isOpen) => {
    setPopoverStates(isOpen ? { [itemId]: isOpen } : {});
  };
  const { getColumnConfigs } = useColumnConfig();
  const handleHeaderDoubleClick = (columnId, currentHeader) => {
    setEditingHeader(columnId);
    setHeaderValue(currentHeader);
  };

  const handleHeaderSave = (columnId) => {
    if (!headerValue.trim()) {
      dispatch(
        generalActions.showToast({
          title: "Header name cannot be empty",
          type: "error",
        })
      );
      return;
    }

    const updatedColumnsDB = cols.map((col) => ({
      name: col.Label,
      customName: col.accessorKey === columnId ? headerValue : col.CustomName,
      order: col.Order,
      isVisible: col.Visibility,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumnsDB,
    };

    userService
      .putUserLayoutRequest(payload)
      .then(() => { })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column header",
            type: "error",
          })
        );
      })
      .finally(() => {
        setColumnsList((prevCols) => {
          const newCols = prevCols.map((col) =>
            col.accessorKey === columnId
              ? { ...col, header: headerValue, customName: headerValue }
              : col
          );
          return newCols;
        });
      });

    setEditingHeader(null);
    setHeaderValue("");
  };

  const handleRedirect = (item) => {
    if (overviewType === "Dashboard") {
      dashboardFilterSetId(item.id);
      dashboardFilterSetName(item.name);
      return;
    }
    // Use navigation hook instead of localStorage
    navigateTo("Portfolios", item.id, item.name);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handlePortfolioRedirect = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo("Portfolios", item.portfolio.id, item.portfolio.name);
      } else {
        // Already in portfolio context, just navigate
        history.push(`/portfolio/${item.portfolio.id}/overview`);
      }
    }
  };

  const handleProgramRedirect = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        history.push(`/program/${item.program.id}/overview`);
      }
    }
  };

  const handleProjectRedirect = (item) => {
    if (overviewType === "Dashboard") {
      dashboardFilterSetId(item.project.id);
      dashboardFilterSetName(item.project.name);
      return;
    }
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  const handleFlag = (id, status) => {
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.id === id);
    if (index !== -1) {
      newData[index].isFlagged = status;
    }

    setRowData(
      newData.sort((a, b) => {
        return b.isFlagged - a.isFlagged;
      })
    );
    dispatch(
      updateRiskFlag({
        id: id,
        payload: [
          {
            op: "replace",
            path: "/IsFlagged",
            value: status,
          },
        ],
      })
    );
  };

  const fetchMoreData = useCallback(() => {
    if (!pagination?.HasNext || riskLoading || isFetchingMore || hasContextChanged) return;
    setIsFetchingMore(true);
    setPageNum(pagination.CurrentPage + 1);
  }, [pagination, riskLoading, isFetchingMore, setPageNum, hasContextChanged]);

  useEffect(() => {
    if (!riskLoading && isFetchingMore) {
      setIsFetchingMore(false);
    }
  }, [riskLoading, rowData.length]);

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement) => {
      if (!containerRefElement || riskLoading || !pagination?.HasNext) return;

      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      const scrolledToBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 50;
      const isScrollingDown = scrollTop > lastScrollTop.current;

      lastScrollTop.current = scrollTop;

      if (isScrollingDown && scrolledToBottom) {
        fetchMoreData();
      }
    },
    [fetchMoreData, riskLoading, pagination]
  );

  const throttledFetchMore = useCallback(
    (() => {
      let timeoutId;
      return (containerRefElement) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fetchMoreOnBottomReached(containerRefElement);
        }, 100);
      };
    })(),
    [fetchMoreOnBottomReached]
  );

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const handleScroll = () => throttledFetchMore(container);
      container.addEventListener("scroll", handleScroll, { passive: true });
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [throttledFetchMore]);

  // Reset scroll position when search is triggered
  useEffect(() => {
    if (tableContainerRef.current && triggerSearch !== undefined) {
      tableContainerRef.current.scrollTop = 0;
      lastScrollTop.current = 0;
    }
  }, [triggerSearch]);

  const formatPayload = (payload) => {
    const formattedPayload = {};
    Object.keys(payload).forEach((key) => {
      formattedPayload[key] = payload[key];
    });
    return formattedPayload;
  };

  const handleSave = (rowId, payload) => {
    if (projectId) {
      dispatch(
        updateRiskRequest({
          id: projectId,
          parentID: projectId,
          parent: "Project",
          payload: { rId: rowId, payload },
        })
      );
      return;
    }
    if (programId) {
      dispatch(
        updateRiskRequest({
          id: projectId,
          parentID: programId,
          parent: "Program",
          payload: { rId: rowId, payload },
        })
      );
      return;
    }
    if (portfolioId) {
      dispatch(
        updateRiskRequest({
          id: portfolioId,
          parentID: portfolioId,
          parent: "Portfolio",
          payload: { rId: rowId, payload },
        })
      );
      return;
    }

    dispatch(
      updateRiskRequest({
        parentID: projectId ?? null,
        parent: "Risk",
        payload: { rId: rowId, payload },
      })
    );

    setEditedRows({});
  };

  const handleCreate = (payload) => {
    if (projectId) {
      dispatch(
        createRiskRequest({
          id: projectId,
          parentID: projectId,
          parent: "Project",
          payload,
          perPageItems,
        })
      );
      return;
    }
    if (programId) {
      dispatch(
        createRiskRequest({
          id: projectId,
          parentID: programId,
          parent: "Program",
          payload,
          perPageItems,
        })
      );
      return;
    }
    if (portfolioId) {
      dispatch(
        createRiskRequest({
          id: portfolioId,
          parentID: portfolioId,
          parent: "Portfolio",
          payload,
          perPageItems,
        })
      );
      return;
    }

    dispatch(
      dispatch(
        createRiskRequest({
          id: projectId,
          parent: "Risk",
          payload,
          perPageItems,
        })
      )
    );
  };

  const getSortingFunction = (col) => {
    switch (col.label) {
      case "Name":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.name || "").toLowerCase();
          const b = (rowB.original.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Client":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.client?.name || "").toLowerCase();
          const b = (rowB.original.client?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Portfolio":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.portfolio?.name || "").toLowerCase();
          const b = (rowB.original.portfolio?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Program":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.program?.name || "").toLowerCase();
          const b = (rowB.original.program?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Project":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.project?.name || "").toLowerCase();
          const b = (rowB.original.project?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Description":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.description || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, ""); // Strip HTML tags
          const b = (rowB.original.description || "")
            .toLowerCase()
            .replace(/<[^>]*>/g, "");
          return a.localeCompare(b);
        };

      case "Change Request":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.changeRequest?.name || "").toLowerCase();
          const b = (rowB.original.changeRequest?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Affected Scope":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.scope?.name || "").toLowerCase();
          const b = (rowB.original.scope?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Affected Task":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.task?.name || "").toLowerCase();
          const b = (rowB.original.task?.name || "").toLowerCase();
          return a.localeCompare(b);
        };
      case "Type":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.type || 0;
          const b = rowB.original.type || 0;
          return a - b;
        };

      case "Prime":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.owner?.name || "").toLowerCase();
          const b = (rowB.original.owner?.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Probability":
        return (rowA, rowB, columnId) => {
          const a = parseFloat(rowA.original.probability) || 1;
          const b = parseFloat(rowB.original.probability) || 1;
          return a - b;
        };

      case "Impact":
        return (rowA, rowB, columnId) => {
          const a = parseFloat(rowA.original.impact) || 1;
          const b = parseFloat(rowB.original.impact) || 1;
          return a - b;
        };

      case "Severity":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.severity || 1;
          const b = rowB.original.severity || 1;
          return a - b;
        };

      case "Status":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.status || 0;
          const b = rowB.original.status || 0;
          return a - b;
        };

      case "Date Identified":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.dateIdentified || 0);
          const b = new Date(rowB.original.dateIdentified || 0);
          return a.getTime() - b.getTime();
        };

      case "Date Resolved":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.dateResolved || 0);
          const b = new Date(rowB.original.dateResolved || 0);
          return a.getTime() - b.getTime();
        };

      case "Date of Impact":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.dateImpact || 0);
          const b = new Date(rowB.original.dateImpact || 0);
          return a.getTime() - b.getTime();
        };

      case "Is Issue":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.isIssue || 0;
          const b = rowB.original.isIssue || 0;
          return a - b;
        };
      case "In WSR":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.isInWsr ? 1 : 0;
          const b = rowB.original.isInWsr ? 1 : 0;
          return b - a; // isInWsr items first
        };
      case "Trending":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.trendingStatus ? 1 : 0;
          const b = rowB.original.trendingStatus ? 1 : 0;
          return b - a; // trending items first
        };
      default:
        return "alphanumeric";
    }
  };

  const getSortDescFirst = (col) => {
    const descFirstColumns = [
      "Type",
      "Probability",
      "Impact",
      "Severity",
      "Status",
      "Date Identified",
      "Date Resolved",
      "Date of Impact",
    ];
    return descFirstColumns.includes(col.label);
  };

  const handleToggleField = (id, field, newValue) => {
    const prevData = [...rowData];
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.id === id);
    if (index === -1) return;
    newData[index] = { ...newData[index], [field]: newValue };
    setRowData(newData);

    riskService
      .patchField(id, field, newValue)
      .catch(() => {
        setRowData(prevData);
        dispatch(
          generalActions.showToast({
            title: `Failed to update risk. Please try again.`,
            type: "error",
          })
        );
      });
  };

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;

    const baseRows = [...rowData];

    if (isFetchingMore && pagination?.HasNext) {
      const skeletonRows = createSkeletonRows();
      setRows([...baseRows, ...skeletonRows]);
    } else {
      setRows(baseRows);
    }
  }, [rowData, isFetchingMore, pagination?.HasNext, colsList]);

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;
    const columnsOrder = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item) => item.accessorKey);
    setColumnOrder(columnsOrder);
    const columns = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((col, index) => {
        return {
          Label: col.label,
          CustomName: col.customName,
          Order: col.order,
          Visibility: col.isVisible,
          accessorKey: col.accessorKey,
          header: col.header,
          enableHiding: true,
          enableColumnActions: false,
          grow: true,
          enableResizing: true,
          size: col.size,
          editVariant: col.columnType,
          enableGlobalFilter: true,
          enableEditing:
            col.accessorKey === "client" ||
              col.accessorKey === "severity" ||
              col.accessorKey === "dateIdentified" ||
              col.accessorKey === "dateImpact" ||
              col.accessorKey === "dateResolved"
              ? false
              : true,
          enableSorting: editingHeader === col.accessorKey ? false : true,
          sortingFn: getSortingFunction(col),
          sortDescFirst: getSortDescFirst(col),
          muiEditTextFieldProps: ({ cell, row }) => ({
            sx: {
              fontFamily: "Figtree-Regular",
              fontSize: "14px",
              padding: "0.5rem",
              maxHeight: "28px",
            },
            required: col.required || false,
            error: !!validationErrors?.[`${row.id}_${cell.column.id}`],
            helperText: validationErrors?.[`${row.id}_${cell.column.id}`],
            onFocus: () =>
              setValidationErrors({
                ...validationErrors,
                [cell.column.id]: undefined,
              }),
            inputRef: (el) => {
              if (col.columnType === "select") {
                selectRefs.current[`${row.id}_${cell.column.id}`] = el;
              }
            },
            onChange: (event) => {
              const newValue = event.target.value;
              setEditedRows((prev) => ({
                ...prev,
                [row.id]: {
                  ...prev[row.id],
                  [cell.column.id]: newValue,
                },
              }));
            },
            onBlur: (event) => {
              const value = event.target.value;
              const validationError =
                col.required && !value ? "Required" : undefined;
              setValidationErrors((prev) => ({
                ...prev,
                [`${row.id}_${cell.column.id}`]: validationError,
              }));
            },
          }),
          Cell: ({ cell, row }) => {
            const item = row.original;
            // Render skeleton for skeleton rows
            if (item.isSkeleton) {
              return (
                <div
                  style={{
                    height: '20px',
                    background: 'linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 1.5s infinite',
                    borderRadius: '4px',
                    width: '100%'
                  }}
                />
              );
            }
            switch (col.label) {
              case "Name":
                return (
                  <div className="d-flex justify-content-between align-items-center inputWidth">
                    <div className="d-flex align-items-center inputWidth">
                      <Tooltip
                        positioning="before"
                        content={{
                          children: item.isFlagged ? "Unflag" : "Flag",
                          className: styles.tooltip,
                        }}
                        relationship="label"
                        withArrow
                      >
                        <span
                          className={`flag ${item.isFlagged ? "flagActive" : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleFlag(item.id, !item.isFlagged);
                          }}
                        >
                          <FlagIcon />
                        </span>
                      </Tooltip>
                      <div className="flex justify-center gap-1 mr-2 min-w-[40px]">
                        {renderHealthStatus({ period: `Risk Trending Status - ${getLabelByType("riskTrending", item.trendingStatus)}`, status: item.trendingStatus, isForecast: true }, item.Id)}
                      </div>
                      <span
                        className="d-flex w-full text-truncate"
                        onClick={(e) => {
                          if (getEditPermission("Risk")) {
                            e.stopPropagation();
                            e.preventDefault();
                            handleEdit(item);
                            handlePopoverChange(
                              item.id,
                              !popoverStates[item.id]
                            );
                          }
                        }}
                      >
                        {item.attachementsCount > 0 && (
                          <div className="mr-1">
                            <AttachementIcon count={item.attachementsCount} />
                          </div>
                        )}
                        {item.isPendingDelete && (
                          <div className="mr-1">
                            <PendingDeleteIcon />
                          </div>
                        )}
                        {item.name}
                      </span>
                      <div className="meatballs-trigger">
                        <Popover
                          open={popoverStates[item.id]}
                          onOpenChange={(e, data) => handlePopoverChange(item.id, data.open || false)}
                          positioning="below-start"
                        >
                          <PopoverTrigger disableButtonEnhancement>
                            <TableCellLayout
                              media={<MeatBallsMenuIcon />}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handlePopoverChange(
                                  item.id,
                                  !popoverStates[item.id]
                                );
                              }}
                            />
                          </PopoverTrigger>
                          <PopoverSurface
                            tabIndex={-1}
                            className="listingPopoverWrapper"
                          >
                            <div className="listingPopoverContent">
                              {/* {getEditPermission("Risk") && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleEdit(item);
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                  }}
                                >
                                  <EditIcon />
                                  <p className="text-sm-400 ms-12">Edit</p>
                                </div>
                              )} */}
                              <div
                                className="popItem"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  handleReminder(item);
                                  handlePopoverChange(
                                    item.id,
                                    !popoverStates[item.id]
                                  );
                                }}
                              >
                                <RemindIcon />
                                <p className="text-sm-400 ms-12">Remind me</p>
                              </div>
                              {getDeletePermission("Risk") && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                    handleDelete(item);
                                  }}
                                >
                                  <DeleteIcon />
                                  <p className="text-sm-400 ms-12">Delete</p>
                                </div>
                              )}
                            </div>
                          </PopoverSurface>
                        </Popover>
                      </div>
                    </div>
                  </div>
                );
              case "Client":
                if (parentType === "Client" || !item || !item.client)
                  return null;
                return (
                  <span
                    onClick={() => handleClientRedirect(item)}
                    className="text-truncate"
                  >
                    {item.client?.name}
                  </span>
                );
              case "Portfolio":
                if (parentType === "Portfolio" || !item || !item.portfolio)
                  return null;
                return (
                  <span
                    onClick={() => handlePortfolioRedirect(item)}
                    className="text-truncate"
                  >
                    {item.portfolio?.name}
                  </span>
                );
              case "Program":
                if (parentType === "Program" || !item || !item.program)
                  return null;
                return (
                  <span onClick={() => handleProgramRedirect(item)}>
                    {item.program?.name}
                  </span>
                );
              case "Project":
                if (!item || !item.project) return null;
                return (
                  <span
                    onClick={() => handleProjectRedirect(item)}
                    className="text-truncate"
                  >
                    {item.project?.name}
                  </span>
                );
              case "Description":
                return <TableCellSafeHtml html={item.description} />;
              case "Change Request":
                return item.changeRequest ? item.changeRequest.name : "";
              case "Affected Scope":
                return item.scope ? item.scope.name : "";
              case "Affected Task":
                return item.task ? item.task.name : "";
              case "Type":
                return `${getRequestType(item.type)}`;
              case "Is Issue":
                return item.isIssue ? (
                  <div className="flex w-100 justify-center items-center">
                    <span className="pill w-100 AtRisk">Issue</span>
                  </div>
                ) : (
                  ""
                );
              case "Prime":
                return item.owner ? (
                  <TableCellLayout
                    media={
                      <HoverCard
                        HoverCardTrigger={
                          <Avatar
                            color="colorful"
                            name={item.owner ? item.owner.name : ""}
                            image={{
                              src: item.owner.image ? item.owner.image : "",
                            }}
                            size={20}
                          />
                        }
                        AvatarId={item.owner?.id}
                        AvatarName={item.owner?.name}
                        AvatarImage={item.owner?.image}
                        AvatarDesignation={item.owner?.title}
                        AvatarEmail={item.owner?.email}
                        AvatarPhone={item.owner?.phoneNumber}
                        AvatarIsExternal={item.owner?.isExternal}
                      />
                    }
                  >
                    {item.owner ? item.owner.name : ""}
                  </TableCellLayout>
                ) : (
                  ""
                );
              case "Probability":
                return item.probability ? item.probability : "";
              case "Impact":
                return item.impact ? item.impact : "";
              case "Severity":
                return (
                  <Tooltip
                    withArrow
                    positioning="after"
                    content={{
                      children: <>{item.severity}</>,
                      className: "ListingTooltip",
                    }}
                    relationship="description"
                  >
                    <div className="flex w-100 justify-center items-center">
                      <p
                        className={`pill w-100 ${getRiskSeverityColorClass(
                          item.severity
                        )}`}
                      >
                        {getRiskSeverityStatus(item.severity)}
                      </p>
                    </div>
                  </Tooltip>
                );
              case "Status":
                return (
                  <div className="flex w-100 justify-center items-center">
                    <p
                      className={`pill w-100 ${item.status === 0 || item.status === 1
                        ? "OnTrack"
                        : item.status === 2
                          ? "OffTrack"
                          : item.status === 3 || item.status === 4
                            ? "AtRisk"
                            : "Completed"
                        }`}
                    >
                      {getRiskStatus(item.status)}
                    </p>
                  </div>
                );
              case "Date Identified":
                return item.dateIdentified
                  ? dateOnlyFormatted(setting, item.dateIdentified)
                  : "";
              case "Date Resolved":
                return item.dateResolved
                  ? dateOnlyFormatted(setting, item.dateResolved)
                  : "";
              case "Date of Impact":
                return item.dateImpact
                  ? dateOnlyFormatted(setting, item.dateImpact)
                  : "";
              case "Mitigation Plan":
                return <TableCellSafeHtml html={item.mitigationPlan} />;
              case "In WSR":
                return (
                  <div
                    className="flex w-100 justify-center items-center cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleToggleField(item.id, "isInWsr", !item.isInWsr);
                    }}
                  >
                    {item.isInWsr ? (
                      <CheckmarkCircleIcon />
                    ) : (
                      <DismissCircleIcon />
                    )}
                  </div>
                );
              case "Trending":
                return (
                  <div className="flex w-100 justify-center items-center">
                    <p
                      className={`pill w-100 ${getRiskTrendingColorClass(item.trendingStatus)}`}
                    >
                      {getLabelByType("riskTrending", item.trendingStatus)}
                    </p>
                  </div>
                );
              default:
                return cell.getValue();
            }
          },
          Edit: ({ cell, row, table }) => {
            const value =
              editedRows[row.id]?.[cell.column.id] ??
              cell.getValue() ??
              row.original[cell.column.id] ??
              (col.columnType === "select" ? null : "");
            return (
              <EditInput
                label={col.label}
                value={value}
                onChange={(newValue) => {
                  if (row.id.startsWith("mrt-row-create")) {
                    table.setCreatingRow((prev) => ({
                      ...prev,
                      values: {
                        ...prev.values,
                        [cell.column.id]: newValue,
                      },
                    }));
                  } else {
                    setEditedRows((prev) => ({
                      ...prev,
                      [row.id]: {
                        ...prev[row.id],
                        [cell.column.id]: newValue,
                      },
                    }));
                  }
                }}
                onBlur={() => {
                  if (!row.id.startsWith("mrt-row-create")) {
                    const newValue = editedRows[row.id]?.[cell.column.id];
                    table.options.onEditingCellSave?.({
                      cell,
                      value: newValue,
                      row,
                      table,
                    });
                    table.setEditingCell(null);
                  }
                }}
                type={col.columnType}
                dateFormat={
                  col.columnType === "date"
                    ? setting.regionalSettings.dateFormat
                    : null
                }
                clientId={row.original?.client?.id}
                portfolioId={portfolioId}
                programId={programId}
                projectId={projectId}
                table={table}
              />
            );
          },
          Header: ({ column }) => {
            return editingHeader === column.id ? (
              <input
                value={headerValue}
                onChange={(e) => setHeaderValue(e.target.value)}
                onBlur={() => handleHeaderSave(column.id)}
                // onKeyPress={(e) => {
                //   if (e.key === "Enter") {
                //     handleHeaderSave(column.id);
                //   }
                // }}
                autoFocus
                className="header-edit-input"
                style={{
                  minWidth: column.getSize() - 60,
                }}
              />
            ) : (
              <span>{column.columnDef.header}</span>
            );
          },
        };
      });
    setCols((prevCols) => {
      if (JSON.stringify(prevCols) !== JSON.stringify(columns)) {
        return columns;
      }
      return prevCols;
    });
  }, [colsList, rowData, editingHeader, headerValue]);

  const table = useMaterialReactTable({
    columns: cols,
    data: rows,
    enableHiding: true,
    enableSorting: true,
    manualSorting: false,
    visibleInShowHideMenu: false,
    enablePagination: false,
    enableTopToolbar: true,
    enableGlobalFilter: true,
    enableStickyHeader: true,
    enableColumnFilterModes: true,
    enableColumnDragging: true,
    enableColumnOrdering: true,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    editDisplayMode: "cell",
    globalFilterFn: "contains",
    enableEditing: false,
    enableFilters: false,
    enableCreatingRow: true,
    createDisplayMode: "row",
    positionCreatingRow: "bottom",
    initialState: {
      density: "compact",
      showGlobalFilter: false,
      showColumnFilters: false,
      enableHiding: false,
      columnOrder: cols.map((col) => col.order),
    },
    state: {
      sorting,
      isLoading: rows.length === 0 && riskLoading,
      columnSizing,
      columnOrder,
      showLoadingOverlay: false,
      showProgressBars: false,
    },
    onSortingChange: setSorting,
    onCreatingRowCancel: () => {
      setValidationErrors({});
      handleCancelAddRow();
    },
    onCreatingRowSave: ({ values, table }) => {
      const errors = {};
      if (!values.name?.trim()) errors["name"] = `The Name field is required.`;
      if (!projectId && !values.project)
        errors["project"] = `Project field is required.`;

      if (Object.keys(errors).length) {
        dispatch(
          generalActions.showToast({
            title: errors.name || errors.project,
            type: "error",
          })
        );
        return;
      }

      const payload = {
        Name: values.name,
        ...(values?.client && { ClientId: values?.client?.id }),
        ProjectId: projectId ? projectId : values.project?.id,
        Description: values?.description,
        ChangeRequestId: values?.changeRequest && values?.changeRequest.id,
        Type: setRequestType(values?.type),
        OwnerId: values?.owner?.id ?? null,
        Probability: values?.probability?.id ?? 1,
        Impact: values?.impact?.id ?? 1,
        Status: setRiskStatus(values?.status),
        IsIssue: values?.isIssue.id,
        MitigationPlan: values?.mitigationPlan,
        DateIdentified: moment().format("YYYY-MM-DD"),
      };
      handleCreate(payload);
      table.setCreatingRow(null);
    },
    onEditingRowCancel: () => {
      setValidationErrors({});
      setEditedRows({});
    },
    positionGlobalFilter: "left",
    onEditingCellSave: ({ cell, row }) => {
      const editedRow = editedRows[row.id];
      const newValue =
        editedRow?.[cell.column.id] !== undefined
          ? editedRow[cell.column.id]
          : cell.getValue();

      if (newValue === cell.getValue()) return; // Skip if no real change
      setRows((prevRows) =>
        prevRows.map((r, index) => {
          if (index === row.index) {
            switch (cell.column.id) {
              case "client":
                return { ...r, client: newValue };
              case "portfolio":
                return { ...r, portfolio: newValue };
              case "program":
                return { ...r, program: newValue };
              case "project":
                return { ...r, project: newValue };
              // case "users":
              //   return { ...r, project: newValue?.id };
              case "type":
                return { ...r, type: newValue?.id };
              case "status":
                return { ...r, status: newValue?.value || newValue?.id };
              case "severity":
                return { ...r, severity: newValue?.id };
              case "impact":
                return { ...r, impact: newValue?.id };
              case "probability":
                return { ...r, probability: newValue?.id };
              case "owner":
                return { ...r, owner: newValue };
              case "isIssue":
                return { ...r, isIssue: newValue?.id };
              default:
                return { ...r, [cell.column.id]: newValue };
            }
          }
          return r;
        })
      );

      // Remove the specific cell edit
      setEditedRows((prev) => {
        const updated = { ...prev };
        if (updated[row.id]) {
          delete updated[row.id][cell.column.id];
          if (Object.keys(updated[row.id]).length === 0) {
            delete updated[row.id];
          }
        }
        return updated;
      });

      const prePayload =
        cell.column.id === "client"
          ? {
            ...row.original,
            ClientId: newValue?.id ?? null,
            portfolioId: row.original.portfolio?.id ?? null,
            ProgramId: row.original.program?.id ?? null,
            ProjectId: row.original.project?.id ?? null,
            ChangeRequestId: row.original.changeRequest?.id ?? null,
            OwnerId: row.original.owner?.id ?? null,
          }
          : cell.column.id === "portfolio"
            ? {
              ...row.original,
              ClientId: row.original.client?.id ?? null,
              portfolioId: newValue?.id ?? null,
              ProgramId: row.original.program?.id ?? null,
              ProjectId: row.original.project?.id ?? null,
              ChangeRequestId: row.original.changeRequest?.id ?? null,
              OwnerId: row.original.owner?.id ?? null,
            }
            : cell.column.id === "program"
              ? {
                ...row.original,
                ClientId: row.original.client?.id ?? null,
                portfolioId: row.original.portfolio?.id ?? null,
                ProgramId: newValue?.id ?? null,
                ProjectId: row.original.project?.id ?? null,
                ChangeRequestId: row.original.changeRequest?.id ?? null,
                OwnerId: row.original.owner?.id ?? null,
              }
              : cell.column.id === "project"
                ? {
                  ...row.original,
                  ClientId: row.original.client?.id ?? null,
                  portfolioId: row.original.portfolio?.id ?? null,
                  ProgramId: row.original.program?.id ?? null,
                  ProjectId: newValue?.id ?? null,
                  ChangeRequestId: row.original.changeRequest?.id ?? null,
                  OwnerId: row.original.owner?.id ?? null,
                }
                : cell.column.id === "type"
                  ? {
                    ...row.original,
                    type: newValue?.id ?? null,
                    ClientId: row.original.client?.id ?? null,
                    portfolioId: row.original.portfolio?.id ?? null,
                    ProgramId: row.original.program?.id ?? null,
                    ProjectId: row.original.project?.id ?? null,
                    ChangeRequestId: row.original.changeRequest?.id ?? null,
                    OwnerId: row.original.owner?.id ?? null,
                  }
                  : cell.column.id === "status"
                    ? {
                      ...row.original,
                      status: newValue?.id ?? null,
                      ClientId: row.original.client?.id ?? null,
                      portfolioId: row.original.portfolio?.id ?? null,
                      ProgramId: row.original.program?.id ?? null,
                      ProjectId: row.original.project?.id ?? null,
                      ChangeRequestId: row.original.changeRequest?.id ?? null,
                      OwnerId: row.original.owner?.id ?? null,
                    }
                    : cell.column.id === "impact"
                      ? {
                        ...row.original,
                        impact: newValue?.id ?? null,
                        ClientId: row.original.client?.id ?? null,
                        portfolioId: row.original.portfolio?.id ?? null,
                        ProgramId: row.original.program?.id ?? null,
                        ProjectId: row.original.project?.id ?? null,
                        ChangeRequestId: row.original.changeRequest?.id ?? null,
                        OwnerId: row.original.owner?.id ?? null,
                      }
                      : cell.column.id === "probability"
                        ? {
                          ...row.original,
                          probability: newValue?.id ?? null,
                          ClientId: row.original.client?.id ?? null,
                          portfolioId: row.original.portfolio?.id ?? null,
                          ProgramId: row.original.program?.id ?? null,
                          ProjectId: row.original.project?.id ?? null,
                          ChangeRequestId: row.original.changeRequest?.id ?? null,
                          OwnerId: row.original.owner?.id ?? null,
                        }
                        : cell.column.id === "owner"
                          ? {
                            ...row.original,
                            OwnerId: newValue?.id ?? null,
                            ChangeRequestId: row.original.changeRequest?.id ?? null,
                            ClientId: row.original.client?.id ?? null,
                            portfolioId: row.original.portfolio?.id ?? null,
                            ProgramId: row.original.program?.id ?? null,
                            ProjectId: row.original.project?.id ?? null,
                          }
                          : cell.column.id === "changeRequest"
                            ? {
                              ...row.original,
                              ChangeRequestId: newValue?.id,
                              ClientId: row.original.client?.id ?? null,
                              portfolioId: row.original.portfolio?.id ?? null,
                              ProgramId: row.original.program?.id ?? null,
                              ProjectId: row.original.project?.id ?? null,
                              OwnerId: row.original.owner?.id ?? null,
                            }
                            : cell.column.id === "isIssue"
                              ? {
                                ...row.original,
                                IsIssue: newValue?.id,
                                ClientId: row.original.client?.id ?? null,
                                portfolioId: row.original.portfolio?.id ?? null,
                                ProgramId: row.original.program?.id ?? null,
                                ProjectId: row.original.project?.id ?? null,
                                OwnerId: row.original.owner?.id ?? null,
                                ChangeRequestId: row.original.changeRequest?.id ?? null,
                              }
                              : cell.column.id === "scope"
                                ? {
                                  ...row.original,
                                  ScopeId: newValue?.id ?? null,
                                  TaskId: row.original.task?.id ?? null,
                                  OwnerId: row.original.owner?.id ?? null,
                                  ChangeRequestId: row.original.changeRequest?.id ?? null,
                                  ClientId: row.original.client?.id ?? null,
                                  portfolioId: row.original.portfolio?.id ?? null,
                                  ProgramId: row.original.program?.id ?? null,
                                  ProjectId: row.original.project?.id ?? null,
                                }
                                : cell.column.id === "task"
                                  ? {
                                    ...row.original,
                                    ScopeId: row.original.scope?.id ?? null,
                                    TaskId: newValue?.id ?? null,
                                    OwnerId: row.original.owner?.id ?? null,
                                    ChangeRequestId: row.original.changeRequest?.id ?? null,
                                    ClientId: row.original.client?.id ?? null,
                                    portfolioId: row.original.portfolio?.id ?? null,
                                    ProgramId: row.original.program?.id ?? null,
                                    ProjectId: row.original.project?.id ?? null,
                                  }
                                  : {
                                    ...row.original,
                                    [cell.column.id]: newValue,
                                    ClientId: row.original.client?.id ?? null,
                                    portfolioId: row.original.portfolio?.id ?? null,
                                    ProgramId: row.original.program?.id ?? null,
                                    ProjectId: row.original.project?.id ?? null,
                                    ChangeRequestId: row.original.changeRequest?.id ?? null,
                                    OwnerId: row.original.owner?.id ?? null,
                                    ScopeId: row.original.scope?.id ?? null,
                                    TaskId: row.original.task?.id ?? null,
                                  };
      const payload = formatPayload(prePayload);
      handleSave(row.original.id, payload);
    },
    onColumnSizingChange: (updater) => {
      setColumnSizing((prev) => {
        const newSizing =
          typeof updater === "function" ? updater(prev) : updater;
        Object.entries(newSizing).forEach(([columnId, width]) => {
          setColumnWidth(tableName, columnId, width);
        });
        return newSizing;
      });
    },
    onColumnOrderChange: (updater) => {
      const newOrder = typeof updater === "function" ? updater() : updater;
      const neworderList = newOrder
        .filter((item) => item !== "mrt-row-spacer")
        .filter(Boolean);
      const areEqual = compareArrays(neworderList, columnOrder);
      if (areEqual) {
        return newOrder;
      }

      const sortedColumns = sortColumnsByOrderlist(colsList, neworderList);
      handleColumnOrdering(sortedColumns);
      setColumnOrder(neworderList);
      return neworderList;
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        fontFamily: "Figtree-Medium",
        fontSize: "14px",
        padding: "1rem 0.5rem 1rem 1rem",
        backgroundColor: "#f5f5f5",
        height: "40px",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "#ece8fd",
        },
        position: "relative",
        "& .Mui-TableHeadCell-Content": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        },
        "& .MuiTableSortLabel-root": {
          marginLeft: "8px",
          paddingTop: "3px",
        },
      },
      onDoubleClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleHeaderDoubleClick(column.id, column.columnDef.header);
      },
    }),
    muiTopToolbarProps: {
      showColumnFilters: false,
      showGlobalFilter: true,
      enableHiding: false,
      sx: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        "& .MuiBox-root": {
          padding: 0,
          display: "flex",
          alignItems: "center",
        },
      },
    },
    renderTopToolbar: () => (
      <ListingHeader
        isHeader={isHeader}
        parentType={parentType ?? "Risk"}
        type="Risk"
        btnLable="Add Risk"
        searchedData={searchHandler}
        setIsCreate={() => setIsCreate(true)}
        rightPane={true}
        projectId={projectId}
        programId={programId}
        portfolioId={portfolioId}
        isCreatable={true}
        isSearchDisable={cols.length}
        handleCreateFunc={() => {
          handleAddRow();
          table.setCreatingRow(true);
        }}
        triggerSearch={triggerSearch}
      />
    ),
    renderBottomToolbarCustomActions: () => (
      <div className="bottom-toolbar-container">
        <div className="toolbar-content">
          {riskLoading || isFetchingMore ? (
            <div className="loading-indicator">
              <span>{`${!isFetchingMore ? 'Loading...' : 'Loading more data...'}`}</span>
            </div>
          ) : pagination?.TotalCount > 0 ? (
            <div className="data-info">
              <span className="data-text">
                Showing <strong>{rows.length}</strong> of{" "}
                <strong>{pagination?.TotalCount || 0}</strong> total records
              </span>
            </div>
          ) : (
            <div className="data-info">
              <span className="data-text">No records Found</span>
            </div>
          )}
        </div>
      </div>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute",
        bottom: 0,
        backgroundColor: "#f5f5f5",
        padding: "0.7rem 1rem",
        width: "100%",
        height: "38px",
      },
    },
    muiTableBodyProps: {
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",

        marginBottom: "66px",
        "& .MuiTableBody-Cell": {
          "&:hover": {
            backgroundColor: "#ece8fd15",
          },
        },
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        height: "32px",
        position: "relative",
        "&:hover": {
          backgroundColor: row.original.isSkeleton ? "transparent" : "#ece8fd15",
        },
        cursor: row.original.isSkeleton ? "default" : "pointer",
      },
      className: row.original.isSkeleton ? "" : "hoverable-row",
    }),
    muiTableContainerProps: ({ table }) => ({
      ref: tableContainerRef,
      sx: {
        height: `calc(100% - ${table.refs.topToolbarRef.current?.offsetHeight || parentType
          ? 115
          : 70
          }px)`,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          height: "8px",
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#342c82",
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: "#342c82",
          },
        },
      },
    }),
    muiTablePaperProps: {
      sx: {
        height: "100%",
      },
    },
    muiSkeletonProps: {
      height: 34,
      sx: {
        background:
          "linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        "@keyframes shimmer": {
          "0%": {
            backgroundPosition: "200% 0",
          },
          "100%": {
            backgroundPosition: "-200% 0",
          },
        },
      },
    },
    muiTableBodyCellProps: ({ cell, column, table }) => ({
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",
        padding: "0.5rem 1rem",
        position: "relative",
        overflow: "visible",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          fontFamily: "Figtree-Medium",
          fontWeight: "bold",
        },
      },
    }),
    muiLinearProgressProps: {
      sx: {
        height: "4px",
        backgroundColor: "#cfc9ff",
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar1Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar2Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-barColorPrimary": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-colorPrimary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-colorSecondary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-barColorSecondary": {
          backgroundColor: "#342c82",
        },
      },
    },
    renderEmptyRowsFallback: () => {
      return riskLoading ? (
        <div className="d-flex justify-content-center">
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="h-full flex flex-col items-center justify-center min-h-[400px] p-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              className="mb-4"
            >
              <path
                d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
                fill="#342C82"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-800 mb-1">
              No data currently available
            </h3>
            <p className="text-gray-600 text-center max-w-md">
              New entries will appear here once created.
            </p>
          </div>
        </div>
      ) : null;
    },
  });

  return <MaterialReactTable table={table} />;
};

export default RiskTable;
